import supabase from "artifact/supabase";
import * as f from "standard/f";
import trait from "standard/trait";
import NotAvaliable from "./notAvaliable";
import status from "./status";
import style from "./style";

class InFuture {
  #card;

  get #validity() {
    return this.#card.validity;
  }

  constructor(card) {
    this.#card = card;
  }

  template() {
    return `
      <a class='${style.study}' ${status.IN_FUTURE}>
        Volte em ${Date.timeUntil(this.#validity)}
      </a>
    `;
  }

  static async create(study) {
    const { data } = await supabase
      .from("card")
      .select("validity")
      .eq("deck", study[trait.deck])
      .gt("validity", study[trait.validity])
      .order("validity", "asc")
      .limit(1)
      .single();

    return f.not.isNil(data) ? new InFuture(data) : NotAvaliable.create();
  }
}

export default InFuture;
